import { client } from './client';

export const getPostsTypes = async () => {
  let { data } = await client.get("post-types");
  return data;
}
